<template>
    <div>

        <!-- Start Blog Details Area -->
        <section class="blog-details-area ptb-80 mt-5">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-md-12">
                        <div class="blog-details-desc">
                            <div class="article-image">
                                <img src="../../../../assets/img/blog-image/1.jpg" alt="image">
                            </div>

                            <div class="article-content">
                                <div class="entry-meta">
                                    <ul>
                                        <li><feather type="clock"></feather> <a href="#">September 31, 2020</a></li>
                                        <li><feather type="user"></feather> <a href="#">Steven Smith</a></li>
                                    </ul>
                                </div>

                                <h3>The security risks of changing package owners</h3>

                                <p>Quuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quia non numquam eius modi tempora incidunt ut labore et dolore magnam dolor sit amet, consectetur adipisicing.</p>

                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in  sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.</p>
                        </div>
                    </div>

                    
                </div>
                 <div class="col-lg-4 col-md-12">
                        <aside class="widget-area" id="secondary">
                            <section class="widget widget_search">
                                <form class="search-form">
                                    <label>
                                        <span class="screen-reader-text">Search for:</span>
                                        <input type="search" class="search-field" placeholder="Search...">
                                    </label>
                                    <button type="submit"><feather type="search"></feather></button>
                                </form>
                            </section>

                            <section class="widget widget_startp_posts_thumb">
                                <h3 class="widget-title">Popular Posts</h3>

                                <article class="item">
                                    <router-link to="/blog-details/WhyECommerce" class="thumb">
                                        <span class="fullimage cover bg1" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 10, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/WhyECommerce">How can eCommerce help your business?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>

                                <article class="item">
                                    <router-link to="/blog-details/NeedWebSide" class="thumb">
                                        <span class="fullimage cover bg2" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 21, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedWebSide">Why does your business need a website?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>

                                <article class="item">
                                    <router-link to="/blog-details/NeedDigitalMarketing" class="thumb">
                                        <span class="fullimage cover bg3" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedDigitalMarketing">Why does your business need digital marketing?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                                
                                <article class="item">
                                    <router-link to="/blog-details/WhyRestudent" class="thumb">
                                        <span class="fullimage cover bg4" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/WhyRestudent">Why does your restaurant need an online website?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                                
                                <article class="item">
                                    <router-link to="/blog-details/AppVsWeb" class="thumb">
                                        <span class="fullimage cover bg5" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/AppVsWeb">App vs Website: which one is better?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                                
                                <article class="item">
                                    <router-link to="/blog-details/NeedApps" class="thumb">
                                        <span class="fullimage cover bg6" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedApps">Why does your business need an app?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                            </section>
                        </aside>
                    </div>
            </div>
            </div>
        </section>
        <!-- End Blog Details Area -->
    </div>
</template>

<script>
export default {
    name: 'WhyRestudent'
}
</script>